module.exports = __webpack_public_path__ + "media/inflate.12cdee9e.webm";